import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import App from './App';
import './services/api';


const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App tab="home" />);

//import api from './services/api';
//
// createRoot.render(
//
//     <App />
//   , document.getElementById('root')
// );


/*
  <React.StrictMode>
    <App />
  </React.StrictMode>,
*/
